import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { Close, Loader } from "../icons";
import Input from "../common/Input";

export default function CampusModal({
  open,
  mode = "add",
  initialValues,
  onClose,
  onSubmit,
  isLoading = false,
}) {
  const [campusName, setCampusName] = useState("");
  const [physicalAddress, setPhysicalAddress] = useState("");

  useEffect(() => {
    if (!open) return;

    if (mode === "edit") {
      setCampusName(initialValues?.name || "");
      setPhysicalAddress(initialValues?.subtitle || "");
      return;
    }

    setCampusName("");
    setPhysicalAddress("");
  }, [open, mode, initialValues]);

  function handleSubmit() {
    const payload = { name: campusName, address: physicalAddress };
    if (onSubmit) onSubmit(payload);
    onClose?.();
  }

  const title = mode === "edit" ? "Update Campus" : "Enroll New Campus";
  const submitLabel = mode === "edit" ? "Save Changes" : "Confirm Enrollment";

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={null}
      panelClassName="max-w-[503px] pt-[30px] pb-[46px] px-0"
      centered={false}
    >
      <div className="w-full">
        <div className="flex items-center justify-between mb-6  px-9">
          <p className="text-xl font-bold leading-6 text-black">{title}</p>

          <button onClick={onClose} aria-label="close">
            <Close />
          </button>
        </div>

        <div className="border-t border-[#E5E5E5] pt-4 sm:pt-10 px-9">
          <div className="mb-6 sm:mb-10 space-y-4 sm:space-y-6">
          <Input
            label=" Campus Name"
            value={campusName}
            onChange={(e) => setCampusName(e.target.value)}
            placeholder="Enter E.g Allied Supplies LTD "
          />

          <Input
            label=" Physical Address"
            value={physicalAddress}
            onChange={(e) => setPhysicalAddress(e.target.value)}
            placeholder="Physical Contact for logistic and returns "
          />
            </div>

          
            <button
              onClick={handleSubmit}
              disabled={isLoading}
              className="w-full bg-[#6D4E8A] text-white py-3 font-bold text-sm rounded-[5px] flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {isLoading && <Loader/>}
              {isLoading ? "Creating" : submitLabel}
            </button>
        
        </div>
      </div>
    </Modal>
  );
}
